import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Button from "../components/ui/button";
import { loginUser } from "../redux/authSlice";

export default function Login() {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const loginSchema = Yup.object().shape({
    email: Yup.string().required("This field is required"),
    password: Yup.string().required("Password is required"),
  });

  const initialValues = {
    email: "",
    password: "",
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#3490dc] to-[#6574cd] p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-3xl font-bold text-center text-[#3490dc] mb-6">
          Welcome to Questa
        </h2>

        <Formik
          initialValues={initialValues}
          validationSchema={loginSchema}
          onSubmit={async (values, {resetForm}) => {
            dispatch(loginUser(values))
              .unwrap()
              .then((res) => {
                toast.success("You are logged in now, welcome back");
                const user = res?.user;
                navigate(`/dashboard/${user.publicId}`);
              })
              .catch((err) => {
                console.error("Login failed:", err);
                navigate("/login")
                toast.error(
                  err.message || "Login failed. Please check your email or password."
                );
              });
            // Add real login logic here
          }}
        >
          {({ touched, errors }) => (
            <Form className="space-y-4">
              <div>
                <label className="block font-medium text-sm text-gray-700 mb-1">
                    Email
                </label>
                <Field
                  name="email"
                  className={`w-full px-4 py-2 rounded-lg border ${
                    errors.email && touched.email
                      ? "border-red-500"
                      : "border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-[#3490dc]`}
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-red-500 text-xs mt-1"
                />
              </div>

              <div>
                <label className="block font-medium text-sm text-gray-700 mb-1">
                  Password
                </label>
                <Field
                  name="password"
                  type="password"
                  className={`w-full px-4 py-2 rounded-lg border ${
                    errors.password && touched.password
                      ? "border-red-500"
                      : "border-gray-300"
                  } focus:outline-none focus:ring-2 focus:ring-[#3490dc]`}
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-red-500 text-xs mt-1"
                />
              </div>

              <Button type="submit" className="w-full mt-4">
                Login
              </Button>
            </Form>
          )}
        </Formik>
          <div className="mt-4 text-center text-sm text-gray-600">
            Don’t have an account?{" "}
            <Link
              to="/register"
              className="text-[#3490dc] font-medium hover:underline"
            >
              Register here
            </Link>
          </div>
      </div>
    </div>
  );
}
